var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCommunity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1154 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M866 26c-47 0-100 23-160 68-44 33-87 74-129 124-42-50-85-91-129-124-60-45-113-68-159-68-59 0-112 14-157 43-42 28-75 66-98 116C11 234 0 289 0 349c0 57 20 118 60 183 34 56 82 113 143 173 49 49 106 98 171 147 46 35 94 69 143 100l60 39 60-37c49-32 97-65 143-100 65-48 122-97 171-145 61-58 109-114 143-168 40-63 60-122 60-176 0-63-12-120-35-171s-55-92-97-122c-46-31-97-46-156-46z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommunity);
export default __webpack_public_path__ + "static/media/ic_community.d9d489114c8b21352b4157e33aa65ee5.svg";
export { ForwardRef as ReactComponent };